import { useState } from 'react';
import Sidebar from './components/Sidebar/Sidebar';
import RoleManagement from './pages/RoleManagement/RoleManagement';
import StageTemplateManager from './pages/StageTemplateManager/StageTemplateManager';
import ProfileManager from './pages/ProfileManager/ProfileManager';
import LeadsPage from './pages/LeadsPage/LeadsPage';
import ClientJourney from './pages/ClientJourney/ClientJourney';
import ClientProfile from './pages/ClientProfile/ClientProfile';
import ProspectsPage from './pages/ProspectsPage/ProspectsPage';
import './App.css';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activePage, setActivePage] = useState('roles');

  return (
    <div className={`app-shell ${sidebarOpen ? 'sidebar-expanded' : 'sidebar-collapsed'}`}>
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
        activePage={activePage}
        onNavigate={setActivePage}
      />
      <main className={`main-content ${activePage === 'clients' || activePage === 'clientProfile' || activePage === 'leads' || activePage === 'prospects' ? 'main-content--flush' : ''}`}>
        {activePage === 'roles' && <RoleManagement />}
        {activePage === 'pipeline' && <StageTemplateManager />}
        {activePage === 'profiles' && <ProfileManager />}
        {activePage === 'leads' && <LeadsPage />}
        {activePage === 'prospects' && <ProspectsPage />}
        {activePage === 'clients' && <ClientJourney />}
        {activePage === 'clientProfile' && <ClientProfile />}
      </main>
    </div>
  );
}

export default App;
